import axios from 'axios'

export default {
  /**
   * 获取案例搜索联想数据
   * @return {Promise<AxiosResponse<T>>}
   */
  getCaseSearchSeggestList (keyword) {
    return axios.get('/judgement-search/api/v1/search/recommend/suggest?keyword=' + encodeURIComponent(keyword))
  },
  /**
   * 获取法规搜索联想数据
   * @return {Promise<AxiosResponse<T>>}
   */
  getLawSearchSeggestList (keyword) {
    return axios.get('/ilawregu-search/api/v1/lawregu/recommend/suggest?keyword=' + encodeURIComponent(keyword))
  },
  /**
   * 获取实务文章搜索联想数据
   * @return {Promise<AxiosResponse<T>>}
   */
  getArticleSearchSeggestList (keyword) {
    return axios.get('/iarticle-search/api/v1/article/recommend/suggest?keyword=' + encodeURIComponent(keyword))
  },
  /**
   * 获取司法观点搜索联想数据
   * @return {Promise<AxiosResponse<T>>}
   */
  getJudicialViewSearchSeggestList (keyword) {
    return axios.get('/judicialview/api/v1/judicialview/suggest?fields=keywords&fields=viewTitle&fields=labelName&keyword=' + encodeURIComponent(keyword))
  },
  /**
   * 获取快捷操作权限
   * @return {Promise<AxiosResponse<T>>}
   */
  getShortCutOperateAuthority (type) {
    return axios.post('/matterserver/api/v1/homePage/shortcut/' + type, { type })
  },
  /**
   * 查询今日任务
   * @param {*} { taskId }
   * @returns
   */
  getTaskList ({ userIds, mpListType, status, pageIndex = 1, pageSize = 5 }) {
    return axios.get(`/taskserver/api/v1/tasks/mp/listByType?mpListType=${mpListType}&userIds=${userIds}&status=${status}&pageIndex=${pageIndex}&pageSize=${pageSize}`)
  },
  getUsers () {
    return axios.get('/im/v1/users')
  },
  /**
   * 完成任务
   * @param {*} { taskId }
   * @returns
   */
  finishTask (taskId) {
    return axios.put(`/taskserver/api/v1/tasks/${taskId}/finish`)
  },
  /**
   * 重启任务
   * @param {*} { taskId }
   * @returns
   */
  restartTask (taskId) {
    return axios.put(`/taskserver/api/v1/tasks/${taskId}/restart`)
  },
  /**
   * 获取待办审批列表（新所）
   * @param {*}
   * @returns
   */
  getApproListNew ({ approTypes, arriveTimeFrom, arriveTimeTo, matterIds, preStatus, startTimeFrom, startTimeTo, startUserIds, status, pageIndex = 1, pageSize = 5 }) {
    return axios.get(`/appro/api/v2/appros/approvals?pageSize=${pageSize}&approTypes=${approTypes}&arriveTimeTo=${arriveTimeTo}&arriveTimeFrom=${arriveTimeFrom}&matterIds=${matterIds}&preStatus=${preStatus}&startTimeFrom=${startTimeFrom}&startTimeTo=${startTimeTo}&startUserIds=${startUserIds}&status=${status}&pageIndex=${pageIndex}`)
  },
  /**
   * 获取待办审批列表（旧所）
   * @param {*}
   * @returns
   */
  getApproListOld ({ approTypes, arriveTimeFrom, arriveTimeTo, matterIds, preStatus, startTimeFrom, startTimeTo, startUserIds, status, pageIndex = 1, pageSize = 5 }) {
    return axios.get(`/appro/api/v1/appros/?size=${pageSize}&approTypes=${approTypes}&startUserIds=${startUserIds}&status=${status}&page=${pageIndex}`)
  },
  /**
   * 获取最近浏览任务列表
   * @param {*}
   * @returns
   */
  getRecentlyTask () {
    return axios.get(`/taskserver/api/v1/tasks/recentlyViewed?size=5`)
  },
  /**
   * 最近浏览任务查看权限
   * @param {*}
   * @returns
   */
  getTaskInfo (taskId) {
    return axios.get(`/taskserver/api/v1/tasks/${taskId}`)
  },
  /**
   * 获取最近浏览项目列表
   * @param {*}
   * @returns
   */
  getRecentlyMatter () {
    return axios.get(`/matterserver/api/v2/matter/recentlyViewed?size=5`)
  },
  /**
   * 获取最近浏览文档列表
   * @param {*}
   * @returns
   */
  getRecentlyDocument () {
    return axios.get(`/preview//api/v1/document/recentlyViewed?size=5`, {
      headers: {
        authorization: 'Token ' + localStorage.iFileToken
      }
    })
  },
  /**
   * 获取最近浏览合同列表
   * @param {*}
   * @returns
   */
  getRecentlyContract () {
    return axios.get(`/finance/api/integration/v1/contracts/recentlyViewed?size=5`)
  },
  /**
   * 获取文档在线预览
   * @param {*}
   * @returns
   */
  getDocumentPreview ({ commitId, fileName, filePath, repo }) {
    return axios.get(`/preview/api/v1/document/preview?commitId=${commitId}&fileName=${fileName}&filePath=${filePath}&repo=${repo}`, {
      headers: {
        authorization: 'Token ' + localStorage.iFileToken
      }
    })
  },
  /**
   * 获取精品内容列表
   * @param {*}
   * @returns
   */
  getExquisiteContent (type, pageIndex, pageSize) {
    return axios.get(`/recommend/api/v1/recommend?recommendType=${type}&pageIndex=${pageIndex}&pageSize=${pageSize}`)
  },
  /**
   * 是否有使用工具大数据权限
   * @param {*}
   * @returns
   */
  getToolsPermissionForBigData () {
    return axios.get(`/permission/api/v1/permission/auth/hasRight?permissionString=DEP:modules.tools:useBigData`)
  },
  /**
   * 查询历史记录
   * @param {*}
   * @returns
   */
  getHistoryList ({ pageIndex, pageSize, position, type }) {
    return axios.get(`/cart/api/v1/record/Records?pageIndex=${pageIndex}&pageSize=${pageSize}&position=${position}&type=${type}`)
  },
  /**
   * 获取是否 GPT
   * @param {*}
   * @returns
   */
  getIsGPTUser ({officeId, userId}) {
    return axios.get(`/ai/provider/alpha/gpt/exist?officeId=${officeId}&userId=${userId}`)
  },
}
